import { normalizeActivityLabel } from "./streamActivityLabels";
import { upsertRow } from "./timelineRows";
import { reuseByLabel } from "./streamEventActivityStart";

const timestamp = () => new Date().toISOString();

function closeKnown(rows, event, label, status) {
  const known = rows.some((item) => item.id === event.activity_id);
  const patch = { id: event.activity_id, status, finishedAt: timestamp() };
  if (event.label || !known) patch.label = label;
  if (event.tool) patch.tool = event.tool;
  if (event.task_id) patch.taskId = event.task_id;
  if (event.attribution) patch.attribution = event.attribution;
  return upsertRow(rows, patch);
}

export function closeMatchingActivity(rows, event) {
  const status = event.status === "error" ? "failed" : "succeeded";
  const label = normalizeActivityLabel(event.label ?? "Finished a step");
  if (event.activity_id) return closeKnown(rows, event, label, status);
  for (let i = rows.length - 1; i >= 0; i -= 1) {
    if (
      rows[i].status === "running" &&
      rows[i].tool === (event.tool ?? rows[i].tool)
    ) {
      const next = rows.slice();
      next[i] = {
        ...next[i],
        status,
        finishedAt: timestamp(),
        label: event.label ? label : next[i].label,
      };
      return next;
    }
  }
  return (
    reuseByLabel(rows, label, { status, finishedAt: timestamp() }) ?? [
      ...rows,
      {
        id: `${event.run_id}:${event.sequence}:result`,
        tool: event.tool ?? null,
        label,
        status,
        startedAt: timestamp(),
        finishedAt: timestamp(),
      },
    ]
  );
}
